module.exports = __webpack_public_path__ + "img/home.0cbbc4d1.jpeg";